export function LoadingScreen() {
  return (
    <div className="loading-screen" role="status">
      <div className="loading-mark" />
      <strong>Opening your store</strong>
      <span>Loading products and branch availability...</span>
    </div>
  );
}

export function ProductSkeletons({ count = 10 }: { count?: number }) {
  return (
    <div className="product-grid" aria-label="Loading products">
      {Array.from({ length: count }, (_, index) => (
        <div className="product-card skeleton-card" key={index}>
          <div className="skeleton skeleton-image" />
          <div className="skeleton h-4 w-4/5" />
          <div className="skeleton h-3 w-2/5" />
          <div className="skeleton h-8 w-full" />
        </div>
      ))}
    </div>
  );
}
